import moment from 'moment';

export function datasSelecionadasSemHorario(datas) {
  const inicio = moment(datas[0]).format('YYYY-MM-DD');
  const fim = moment(datas[1]).format('YYYY-MM-DD');

  return  [inicio, fim];

}
